import { api } from "./api/client";
import type { DecisionBucket, DecisionEvento, DecisionItem, DecisionMetrics, Id } from "@/types";

/**
 * Decision Center: datos reales del backend, sin fallback a mocks para que una
 * decisión nunca quede sólo en memoria.
 */
export const decisionsService = {
  list: async (): Promise<DecisionItem[]> => (await api.get<DecisionItem[]>("/decisions")).data,

  metrics: async (): Promise<DecisionMetrics> =>
    (await api.get<DecisionMetrics>("/decisions/metrics")).data,

  historial: async (licitacionId: Id): Promise<DecisionEvento[]> =>
    (await api.get<DecisionEvento[]>(`/decisions/${licitacionId}/historial`)).data,

  decide: async (licitacionId: Id, bucket: DecisionBucket, motivo = "") =>
    (await api.patch(`/decisions/${licitacionId}`, { bucket, motivo })).data,

  /** Reabre una decisión: vuelve a quedar pendiente y deja rastro en la bitácora. */
  reabrir: async (licitacionId: Id) => (await api.delete(`/decisions/${licitacionId}`)).data,
};

